// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul li p[data-v-bd7d4d46]{font-size:14px!important;color:#fff!important}ul li .blue[data-v-bd7d4d46]{color:#2a82e4!important}ul li .orange[data-v-bd7d4d46]{color:#fa8052!important}ul li .red[data-v-bd7d4d46]{color:#e25453!important}", ""]);
// Exports
module.exports = exports;
